import {NgModule} from "@angular/core"
import {RouterModule, Routes} from "@angular/router"
import {RedirectGuard} from "src/app/redirect/RedirectGuard"

const routes: Routes = [
    {
        path: "**",
        canActivate: [RedirectGuard],
        component: RedirectGuard
    }
]

@NgModule({
    imports: [RouterModule.forRoot(routes, {
        scrollPositionRestoration: "top"
    })],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
